<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />

    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout py-2 wrap justify-center px-2>
      <v-flex xs12 sm12 md8 text-left>
        <span style="font-size:22px;font-weight:600">Latest Feeds</span>
      </v-flex>
    </v-layout>
    <v-layout py-2 wrap justify-center>
      <v-flex xs12 sm12 md5 text-left px-2 pb-2>
        <div v-for="(item,i) in latestImage" :key="i">
          <v-layout wrap py-4>
            <v-flex xs12 sm4 md4 px-2>
              <v-img
                v-if="item.type=='Normal Blog'"
                height="120px"
                :src="baseURL+'/u/'+item.image"
                contain
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-img v-else height="120px" :src="baseURL+'/u/'+item.thumbnail" contain>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-flex>
            <v-flex xs12 sm8 md8 px-2>
              <router-link :to="'/Blog/'+item._id">
                <v-layout wrap>
                  <v-flex>
                    <span style="font-size:14px;font-weight:500;color:#000">{{item.title}}</span>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex text-left style="line-height:1" text-justify>
                    <span
                      style="font-size:12px;font-weight:400;color:#000"
                    >{{item.shortDescription.substring(0, 150) + "..."}}</span>
                  </v-flex>
                </v-layout>
              </router-link>
              <v-layout pt-1>
                <v-flex text-left style="line-height:1">
                  <span style="font-size:12px;font-weight:500;">{{item.author}}</span>
                  <br />
                  <span style="font-size:12px;font-weight:400;">{{formatDate(item.createddate)}}</span>
                </v-flex>
                <v-flex text-right align-center>
                  <span style="font-size:10px">
                    <v-icon
                      :color="item.isBookMarked ? '#1fb07c' :'#a9a9a9'"
                      @click="bookmark(item,i,'image')"
                    >mdi-bookmark-outline</v-icon>
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- <v-divider></v-divider> -->
        </div>
      </v-flex>
      <v-flex xs12 sm12 md3 text-left px-2>
        <div v-for="(item,i) in latestVideo" :key="i">
          <v-layout wrap>
            <v-flex text-left px-2 xs12 sm4 md12>
              <v-img height="150px" :src="baseURL+'/u/'+item.thumbnail" contain>
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-flex>
            <v-flex xs12 sm8 md12>
              <router-link :to="'/Blog/'+item._id">
                <v-layout wrap px-2>
                  <v-flex xs12 sm12 md12>
                    <span style="font-size:14px;font-weight:500;color:#000">{{item.title}}</span>
                  </v-flex>
                  <v-flex style="line-height:1" text-justify xs12 sm12 md12>
                    <span
                      style="font-size:12px;font-weight:400;color:#000"
                    >{{item.shortDescription.substring(0, 150) + "..."}}</span>
                  </v-flex>
                </v-layout>
              </router-link>
              <v-layout pt-1 wrap>
                <v-flex text-left style="line-height:1" px-2>
                  <span style="font-size:12px;font-weight:500;">{{item.author}}</span>
                  <br />
                  <span style="font-size:12px;font-weight:400;">{{formatDate(item.createddate)}}</span>
                </v-flex>
                <v-flex text-right align-center px-2>
                  <span style="font-size:10px">
                    <v-icon
                      :color="item.isBookMarked ? '#1fb07c' :'#a9a9a9'"
                      @click="bookmark(item,i,'video')"
                    >mdi-bookmark-outline</v-icon>
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <v-layout py-2 wrap justify-center>
          <v-flex>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex py-2 style="background-color:#efefef;">
            <v-layout py-2 wrap>
              <v-flex px-2>
                <span style="font-size:18px;font-weight:600">Popular</span>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout wrap>
              <v-flex px-2>
                <div v-for="(item,i) in popular" :key="i">
                  <v-layout py-2 wrap>
                    <v-flex xs2 sm2 md2 text-left style="line-height:1" text-center px-2>
                      <span>
                        <v-icon>mdi-star-outline</v-icon>
                      </span>
                    </v-flex>
                    <v-flex xs10 sm10 md10>
                      <router-link :to="'/Blog/'+item._id">
                        <v-layout>
                          <v-flex>
                            <span style="font-size:14px;font-weight:500;color:#000">{{item.title}}</span>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex text-justify style="line-height:1">
                            <span
                              style="font-size:12px;font-weight:400;color:#000"
                            >{{item.shortDescription.substring(0, 150) + "..."}}</span>
                          </v-flex>
                        </v-layout>
                      </router-link>
                      <v-layout pt-1 wrap>
                        <v-flex text-left style="line-height:1">
                          <span style="font-size:12px;font-weight:500;">{{item.author}}</span>
                          <br />
                          <span
                            style="font-size:12px;font-weight:400;"
                          >{{formatDate(item.createddate)}}</span>
                        </v-flex>
                        <v-flex text-right align-center px-2>
                          <span style="font-size:10px">
                            <v-icon
                              :color="item.isBookMarked ? '#1fb07c' :'#a9a9a9'"
                              @click="bookmark(item,i,'popular')"
                            >mdi-bookmark-outline</v-icon>
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout pt-2 wrap justify-center>
      <v-flex xs12 sm12 md8>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ["blogData"],
  data() {
    return {
      latestImage: [],
      latestVideo: [],
      popular: [],
      appLoading: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      ServerError: false
    };
  },
  mounted() {
    this.latestImage = this.blogData.latestimage;
    this.latestVideo = this.blogData.latestvideo;
    this.popular = this.blogData.popular;
  },
  methods: {
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    bookmark(item, index, type) {
      if (localStorage.getItem("token")) {
        this.appLoading = true;
        axios({
          method: "POST",
          url: "/blog/bookmark",
          headers: {
            "x-auth-token": localStorage.getItem("token")
          },
          data: {
            id: item._id,
            status: !item.isBookMarked
          }
        })
          .then(response => {
            this.appLoading = false;
            if (type == "image") {
              this.latestImage[index].isBookMarked = !this.latestImage[index]
                .isBookMarked;
            } else if (type == "video") {
              this.latestVideo[index].isBookMarked = !this.latestVideo[index]
                .isBookMarked;
            } else if (type == "popular") {
              this.popular[index].isBookMarked = !this.popular[index]
                .isBookMarked;
            }
            this.msg = response.data.msg;
            this.showsnackbar = true;
          })
          .catch(err => {
            this.msg = err;
            this.ServerError = true;
          });
      } else {
        this.msg = "Please login to Bookmark";
        this.showsnackbar = true;
      }
    }
  }
};
</script>
<style scoped>
.footer_text {
  font-size: 14px;
  font-weight: 300;
  color: #9a9a9a;
}
</style>